export default function fileConverter(file: File): any {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (!reader.result) {
        reject();
      }
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject();
    };
  });
}
